import React, { useState } from 'react';
import { Text, Stack, Image } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
import chromeIncognitoEn from '../../../media/img/chrome-incognito-en.png';
import firefoxIncognitoEn from '../../../media/img/firefox-incognito-en.png';
import edgeIncognitoEn from '../../../media/img/edge-incognito-en.png';
import chromeIncognitoDe from '../../../media/img/chrome-incognito-de.png';
import firefoxIncognitoDe from '../../../media/img/firefox-incognito-de.png';
import edgeIncognitoDe from '../../../media/img/edge-incognito-de.png';

const TestConnection: React.FC<{}> = () => {
    const userLanguage = localStorage.getItem('UserLanguageChoice') || 'de';
    const [copied, setCopied] = useState(false);

    const browserImages = {
        en: {
            chrome: chromeIncognitoEn,
            firefox: firefoxIncognitoEn,
            edge: edgeIncognitoEn
        },
        de: {
            chrome: chromeIncognitoDe,
            firefox: firefoxIncognitoDe,
            edge: edgeIncognitoDe
        }
    };

    const handleCopy = async () => {
        await navigator.clipboard.writeText('https://test.8x8.vc/');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    };

    return (
        <Stack tokens={{ childrenGap: 20 }} style={{ width: '100%', height: 600, border: '1px dashed #ccc', padding: 16, borderRadius: 4, overflow: 'auto' }}>
            <Text variant="xLarge" block>
                {IvicosStrings.webRTCDiagnosticsShowTestEnvironment.title}
            </Text>
            <Text variant="large" block style={{ backgroundColor: 'rgba(0,0,0,0.05)', padding: '8px 12px', borderRadius: '4px', width: 'fit-content' }}>
                {IvicosStrings.webRTCDiagnosticsShowTestEnvironment.step1}
            </Text>
            <Text>{IvicosStrings.webRTCDiagnosticsShowTestEnvironment.step1Description}</Text>

            <Stack tokens={{ childrenGap: 16 }} style={{ marginTop: 16 }}>
                <Stack horizontal horizontalAlign="space-between" style={{ width: '100%' }}>
                    {[
                        {
                            src: browserImages[userLanguage as keyof typeof browserImages].chrome,
                            title: 'Chrome/Brave',
                            alt: 'Chrome/Brave Incognito Mode',
                            command: IvicosStrings.webRTCDiagnosticsShowTestEnvironment.command1
                        },
                        {
                            src: browserImages[userLanguage as keyof typeof browserImages].firefox,
                            title: 'Firefox',
                            alt: 'Firefox Private Mode',
                            command: IvicosStrings.webRTCDiagnosticsShowTestEnvironment.command2
                        },
                        {
                            src: browserImages[userLanguage as keyof typeof browserImages].edge,
                            title: 'Edge',
                            alt: 'Edge InPrivate Mode',
                            command: IvicosStrings.webRTCDiagnosticsShowTestEnvironment.command1
                        }
                    ].map((browser, i) => (
                        <Stack key={i} tokens={{ childrenGap: 8 }} style={{ maxWidth: '30%', alignItems: 'center' }}>
                            <Text variant="mediumPlus" style={{ fontWeight: 600 }}>
                                {browser.title}
                            </Text>
                            <Image
                                src={browser.src}
                                alt={browser.alt}
                                style={{
                                    width: '100%',
                                    height: 'auto'
                                }}
                            />
                            <Text
                                style={{
                                    textAlign: 'center',
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: '#0078d4',
                                    backgroundColor: '#f5f5f5',
                                    padding: '4px 8px',
                                    borderRadius: 4
                                }}
                            >
                                {browser.command}
                            </Text>
                        </Stack>
                    ))}
                </Stack>
            </Stack>

            <Text variant="large" block style={{ backgroundColor: 'rgba(0,0,0,0.05)', padding: '8px 12px', borderRadius: '4px', width: 'fit-content' }}>
                {IvicosStrings.webRTCDiagnosticsShowTestEnvironment.step2}
            </Text>

            <Stack tokens={{ childrenGap: 8 }}>
                <Stack
                    horizontal
                    verticalAlign="center"
                    style={{
                        padding: '8px 12px',
                        backgroundColor: '#f5f5f5',
                        border: '1px solid #ccc',
                        borderRadius: 4,
                        width: 'fit-content'
                    }}
                >
                    <Text variant="medium" style={{ marginRight: 12 }}>
                        https://test.8x8.vc/
                    </Text>
                    <Text variant="medium" style={{ color: '#0078d4', cursor: 'pointer' }} onClick={handleCopy}>
                        {copied ? IvicosStrings.webRTCDiagnosticsShowTestEnvironment.linkCopied : IvicosStrings.webRTCDiagnosticsShowTestEnvironment.copyLink}
                    </Text>
                </Stack>
            </Stack>

            <Text style={{ color: '#8B0000' }}>{IvicosStrings.webRTCDiagnosticsShowTestEnvironment.step3}</Text>
        </Stack>
    );
};

export default TestConnection;
